document.addEventListener("DOMContentLoaded", function() {
    const questions = document.querySelectorAll('.question');

    questions.forEach(function(question) {
        question.addEventListener('click', function() {
            const answer = this.nextElementSibling;

            if (answer.classList.contains('expanded')) {
                answer.classList.remove('expanded');
                this.querySelector('.expand-icon').innerText = '+';
            } else {
                answer.classList.add('expanded');
                this.querySelector('.expand-icon').innerText = '-';
            }
        });
    });
});